import React, { ReactNode, useEffect } from 'react'

import { PanelStepsProvider, usePanelSteps } from './ContextProvider'

const stepComponentName = 'PanelSteps.Step'

interface PanelStepsProps {
  children: ReactNode
}

type PanelStepsContentProps = {
  validChildren: ReactNode[]
}

const PanelStepsContent = ({ validChildren }: PanelStepsContentProps) => {
  const { setSteps, setCurrentStep } = usePanelSteps()

  useEffect(() => {
    setSteps(
      validChildren.map((item, index): Step => {
        return {
          id: index
        }
      })
    )
    setCurrentStep(0)
  }, [setSteps])

  return validChildren.map((child, index) => (
    <div className="panelsteps-step-item" data-step={index} key={index}>
      {child}
    </div>
  ))
}

const PanelSteps: React.FC<PanelStepsProps> = ({ children }) => {
  const validChildren = React.Children.toArray(children).filter(child => {
    return (
      React.isValidElement(child) &&
      (child.type as React.ComponentType).displayName === stepComponentName
    )
  })

  // const validChildren = useMemo(() => {
  //   console.log('validChildren', children)
  //   return React.Children.toArray(children).filter(child => {
  //     return (
  //       React.isValidElement(child) &&
  //       (child.type as React.ComponentType).displayName === stepComponentName
  //     )
  //   })
  // }, [children])

  if (validChildren.length !== React.Children.count(children)) {
    throw new Error(`${stepComponentName} must be used within PanelSteps.`)
  }

  return (
    <PanelStepsProvider>
      <PanelStepsContent validChildren={validChildren} />
    </PanelStepsProvider>
  )
}

export default PanelSteps
